import Header from "../../../component/header/Header";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/logisticaAttrezzature.json";

const AttrezzatureAnagrafiche = () => {
  const columns = [
    {
      field: "tipologiaAttrezzature",
      headerName: "Tipologia attrezzature",
      width: 485,
    },
    { field: "numeroDiSerie", headerName: "N. di serie", width: 300 },
    { field: "posizione", headerName: "Posizione", width: 300 },
    { field: "creatoIl", headerName: "Da", width: 130 },
    { field: "a", headerName: "A", width: 130 },
    { field: "autore", headerName: "Autore", width: 85 },
    { field: "modDa", headerName: "Mod. da", width: 85 },
    { field: "stato", headerName: "Stato", width: 145 },
    { field: "azioni", headerName: "Azioni", width: 95 },
  ];

  return (
    <>
      <Header />
      <div className="pageTemplate">
        <Table data={tableData} columns={columns} navData={"attrezzature"} />
      </div>
    </>
  );
};

export default AttrezzatureAnagrafiche;
